/*
(function($) {

    $(document).ready(function() {

        //$(".dropdown-toggle:contains('iDogi')").html('stocasso');
        //$(".dropdown-toggle:contains('iDogi')").css("text-transform","lowercase");

    }

})
(jQuery);*/

function replaceIDOGI(){

(function($) {
    //$(document).ready(function() {

    

        var elements = [
            '.dropdown-toggle',
            'h2',
            'h3',
            'h1',
            '.heading-1',
            '.heading-2',
            '.heading-3',
        ];

        var names = [
            //'idogi',
            'iDogi',
            //'iDOGI',
            //'IDOGI'
        ];

        var selected;
        var uppercase;
        var replaced;

        $.each(elements , function(index, element){

            selected = "";
            uppercase = "";
            replaced = "";

            for(let i = 0; i < names.length; i++){
                selected = $( element + ":contains('"+ names[i] + "')");
                if(selected.length > 0){
                    break;
                }
            }


                uppercase = selected.text().toUpperCase();
                replaced = uppercase.replace('IDOGI','iDOGI');

                selected.css("text-transform","initial");

                selected.html(replaced);
            
            
           


        });

        
    

    //});

})
(jQuery);

}